import {styled} from "@mui/material/styles"
import {Typography} from "@mui/material"
import {FALLBACK_FONT_FAMILY} from "@next/ux-fabric"

export type TitleProps = {
    linkColour?: string
    fontWeight?: string
}

export const Container = styled("div")`
    width: 100%;
    height: 2.75rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    border-bottom: 0.0625rem solid
        ${({theme}) => theme.uxfabric.components.menu.megaMenu.navigationList.default.divider.default.borderColor};
`

export const Title = styled(Typography, {
    shouldForwardProp: prop => prop !== "linkColour" && prop !== "fontWeight",
})<TitleProps>`
    color: ${({theme, linkColour}) => linkColour || (theme.uxfabric.text.primary as string)};
    align-items: center;
    display: inherit;
    padding-left: 1rem;
    text-transform: ${({theme}) => `${theme.uxfabric.component.listItemSubtitle2.textTransform}`};
    letter-spacing: ${({theme}) => `${theme.uxfabric.component.listItemSubtitle2.letterSpacing}px`};
    font-size: ${({theme}) => `${theme.uxfabric.component.listItemSubtitle2.fontSize}`};
    font-family: ${({theme}) => `${theme.uxfabric.component.listItemSubtitle2.fontFamily}, ${FALLBACK_FONT_FAMILY}`};
    font-weight: ${({theme, fontWeight}) => fontWeight || theme.uxfabric.component.listItemSubtitle2.fontWeight}};
`
